import HistoriaImg from "../../assets/img/nosotros.png";

function Header() {
  return (
    <main>
      {/* 🔥 HERO BALANCE PERFECTO */}
      <div className="relative px-4 lg:px-6">
        <div className="mx-auto max-w-7xl py-6 lg:py-8">
          
          {/* GRID */}
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 items-center">
            
            {/* 📝 TEXTO */}
            <div>
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight pb-3">
                Historia de la Fundación Arduvi
              </h1>

              <p className="text-base lg:text-lg leading-7 lg:leading-8 text-black">
                En Colombia se estima que 2 millones 588 mil personas, tienen algún tipo de discapacidad y tan solo un 2.6% de estas personas son vinculadas laboralmente a una empresa. Esta realidad y una experiencia vivida en un semáforo conmovió tanto a Arvey Duque Villamizar y a su hija Dayana Duque Espinosa, a crear la Fundación Arduvi con el fin de contribuir a la transformación de las vidas de personas con condiciones especiales, migrantes, población vulnerable y en riesgo social, donde los límites se superen con el corazón y permiten una verdadera inclusión con amor. Con esa misma motivación, crearon Café Arduvi, el cual se ha convertido en el orgullo, no solo familiar sino de Cúcuta, porque es el primer Café en Latinoamérica en el cual más del 80% de sus trabajadores son personas con alguna condición especial y donde cuentan con una vida digna al igual que sus familias.
              </p>
            </div>

            {/* 🖼️ IMAGEN */}
            <div className="flex justify-center">
              <img
                src={HistoriaImg}
                alt="Historia Fundación Arduvi"
                className="
                  w-full
                  max-w-sm
                  lg:max-w-md
                  xl:max-w-lg
                  object-contain
                "
              />
            </div>

          </div>
        </div>
      </div>
    </main>
  );   
}



export default Header;